import { Table } from "../../../features/Table";
import { type A6Issuer, issuers_columns } from "./columns";
import { type FilterA6IssuersSchema, FilterA6Issuers } from "./filter";
import { useTranslation } from "react-i18next";

const client = "a6";
const table_name = "a6_issuers";

export const A6IssuersTable = () => {
  const { t } = useTranslation(["tables"]);
  return (
    <Table<A6Issuer, FilterA6IssuersSchema>
      label={t(`${table_name}.title`, { defaultValue: "Issuers" })}
      client={client}
      table_name={table_name}
      columns={issuers_columns}
      filter={<FilterA6Issuers />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
